
(function () {
  var path = window.location.pathname.toLowerCase().replace(/^\/|\/$/g, '');
  var segments = path.split('/');
  var lang = segments.includes('es') ? 'es' : 'en';

  if (segments[0] === 'es') segments.shift();
  if (segments.length === 0 || segments[0] === '') segments = ['home'];

  var hostSegment = window.location.hostname.replace(/\./g, '-');
  var pageName = `kporg:${lang}:mas:${segments.join(':')}`;
  var base = `kporg:${lang}:mas:${hostSegment}`;

  var subCategory1 = `kporg:${lang}`;
  var subCategory2 = `kporg:${lang}:mas`;
  var subCategory3 = segments.length > 1
    ? `${base}:${segments.slice(0, -1).join(':')}`
    : `${base}`;

  window.digitalData = {
    page: {
      pageInfo: {
        base: base,
        pageName: pageName
      },
      category: {
        primaryCategory: "kporg",
        subCategory1: subCategory1,
        subCategory2: subCategory2,
        subCategory3: subCategory3,
        subCategory4: "",
        subCategory5: ""
      }
    }
  };

  //console.log('digitalData initialized:', window.digitalData);
})();